var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section",staticStyle:{"padding-top":"70px","padding-bottom":"50px"}},[_c('div',{staticClass:"content",staticStyle:{"font-size":"2em","margin":"0 auto","min-height":"600px"}},[_c('div',{staticClass:"main-text",staticStyle:{"margin-top":"30px"}},[_vm._v("Novidades em Breve")])])])
}]

export { render, staticRenderFns }